import React, { useState } from "react";
import { useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  TextField,
  Grid,
  MenuItem,
  TableContainer,
  Slider,
  withStyles,
} from "@material-ui/core";
import { useEffect } from "react";
import {
  getEmployee,
  postEmployee,
  updateEmployee,
  getAgentList,
  getZone,
} from "../../actions/GenomicsAdminAction";
import { useHistory } from "react-router-dom";
import Loader from "../../Components/loader/index";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import { TableFooter, TablePagination } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    centerIt: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

const PrettoSlider = withStyles({
  root: {
    color: "rgb(146, 74, 145)",
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "violet",
    border: "2px solid purple",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

interface Props {
  agentsList: any;
  getAgentList: any;
  postEmployee: any;
  updateEmployee: any;
  getEmployee: any;
  employee: any;
  loading: boolean;
  getZone: any;
  zoneList: any;
}
const EmployeeMaster: React.FC<Props> = ({
  agentsList,
  getAgentList,
  postEmployee,
  updateEmployee,
  getEmployee,
  employee,
  loading,
  getZone,
  zoneList,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [name, setName] = useState<any>("");
  const [dataId, setDataId] = useState<any>("");
  const [dob, setDOB] = useState<any>("");
  const [mobileNumber, setMobileNumber] = useState<any>("");
  const [employeeId, setEmployeeId] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [zoneName, setZoneName] = useState<any>([]);
  const [designation, setDesignation] = useState<any>("");
  const [reporting, setReporting] = useState<any>("");
  const [reportingName, setReportingName] = useState<any>("");
  const [salutation, setSalutation] = useState<any>("");
  const [mobileValidation, setMobileValidation] = useState({
    mobileNumber: true,
  });

  const [editButton, setEditButton] = useState<boolean>(false);
  const verifyMobile = (type: any) => {
    const mobileRegEx = /^[6-9]\d{9}$/;
    if (
      type === "mob" &&
      mobileNumber &&
      !mobileRegEx.test(mobileNumber.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        mobileNumber: false,
      }));
    }
  };

  const salutationData = [
    {
      value: "Mr",
      text: "Mr",
    },
    {
      value: "Master",
      text: "Master",
    },
    {
      value: "Miss",
      text: "Miss",
    },
    {
      value: "Smt",
      text: "Smt",
    },
    {
      value: "Dr.",
      text: "Dr.",
    },
  ];

  useEffect(() => {
    getEmployee();
    getAgentList("", "");
    getZone();
  }, []);

  const handleSubmitCentre = async (e: any) => {
    e.preventDefault();
    const formData = {
      age: dob,
      email: email,
      empid: employeeId,
      gender: gender,
      phonenumber: mobileNumber,
      name: name,
      designation: salutation,
      emp_designation: designation,
      asigned: reporting,
      zone_type: zoneName,
      usergroup: "GenomicsCE",
    };
    const formDataEdit = {
      age: dob,
      email: email,
      empid: employeeId,
      gender: gender,
      phonenumber: mobileNumber,
      fullname: name,
      designation: salutation,
      emp_designation: designation,
      asigned: reporting,
      zone_type: zoneName,
      usergroup: "GenomicsCE",
    };
    if (dob === "") {
      delete formData.age;
    }
    if (editButton) {
      await updateEmployee(formDataEdit, dataId);
    } else {
      await postEmployee(formData);
    }

    setEditButton(false);
    setDOB("");
    setGender("");
    setDesignation("");
    setSalutation("");
    setMobileNumber("");
    setEmail("");
    setName("");
    setEmployeeId("");
    setDataId("");
    setReportingName("");
    getEmployee();
    setZoneName("");
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = employee.links && employee.links.next.split("?")[1];
      getEmployee(`${url}`);
    } else if (newPage < page) {
      let url = employee.links && employee.links.previous.split("?")[1];
      getEmployee(`${url === undefined ? "" : url}`);
    }
    setPage(newPage);
  };

  const handleEditEmployee = (data: any) => {
    setEditButton(true);
    setDOB(data?.age);
    setGender(data?.gender);
    setDesignation(data?.designation);
    setSalutation(data?.salutation);
    setMobileNumber(data?.phonenumber);
    setEmail(data?.email);
    setName(data?.fullname);
    setEmployeeId(data?.empid);
    setDataId(data?.username);
    setZoneName(data?.type);
    setReportingName(String(data?.asigned));
  };
  const search = (val: any) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      getEmployee(`search=${val}`);
    }, 1000);
  };

  useEffect(() => {
    if (salutation === "Mr" || salutation === "Master") {
      setGender("male");
    } else if (salutation === "Smt" || salutation === "Miss") {
      setGender("female");
    }
  }, [salutation]);

  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <form onSubmit={handleSubmitCentre}>
        <Paper elevation={5} className={classes.paper}>
          <h4>EMPLOYEE MASTER</h4>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                variant="outlined"
                label="Designstion"
                value={designation}
                required
                onChange={(e) => setDesignation(e.target.value)}
              >
                <MenuItem value="GM SALES">GM SALES</MenuItem>
                <MenuItem value="AGM SALES">AGM SALES</MenuItem>
                <MenuItem value="ZSM">ZSM</MenuItem>
                <MenuItem value="RBM_RSM">RBM/RSM</MenuItem>
                <MenuItem value="ABM_ASM">ABM/ASM</MenuItem>
                <MenuItem value="SE/TM">SE/TM</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                type="text"
                value={employeeId}
                label="Employee Id"
                variant="outlined"
                required
                onChange={(e) =>
                  setEmployeeId(String(e.target.value).replace(/\s+/g, ""))
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="salutation"
                variant="outlined"
                select
                label="Salutation"
                value={salutation}
                style={{ width: "100%", margin: "0" }}
                onChange={(e) => setSalutation(e.target.value)}
                required
              >
                {salutationData.map((val: any) => {
                  return <MenuItem value={val.value}>{val.text}</MenuItem>;
                })}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Name"
                type="text"
                value={name}
                label="Name"
                required
                variant="outlined"
                onChange={(e) => setName(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="DOB"
                type="number"
                value={dob}
                label="Age(years)"
                variant="outlined"
                onChange={(e) => setDOB(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="customerGender"
                variant="outlined"
                select
                label="Gender"
                value={gender}
                style={{ width: "100%", margin: "0" }}
                onChange={(e) => setGender(e.target.value)}
                required
              >
                <MenuItem value={"male"}>Male</MenuItem>
                <MenuItem value={"female"}>Female</MenuItem>
                <MenuItem value={"other"}>Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="mobile_number"
                type="number"
                label="Mobile Number"
                value={mobileNumber}
                variant="outlined"
                inputProps={{ maxLength: 10 }}
                style={{ margin: "0", width: "100%" }}
                onChange={(e) => setMobileNumber(e.target.value as String)}
                required
                onWheel={(e: any) => e.target.blur()}
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                onBlur={() => verifyMobile("mob")}
                onFocus={() => {
                  setMobileValidation((prev: any) => ({
                    ...prev,
                    mobileNumber: true,
                  }));
                }}
                helperText={
                  !mobileValidation.mobileNumber && "Incorrect Mobile Number"
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="email"
                type="email"
                value={email}
                label="Email "
                variant="outlined"
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="sales_manager"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setReporting(obj.id);
                  }
                }}
                // defaultValue={
                //   sales_ManagerDef || { id: "", user: { username: "" } }
                // }
                options={agentsList.results || []}
                freeSolo
                blurOnSelect
                loading={loading}
                inputValue={reportingName}
                getOptionLabel={(option: any) => `${option.user?.username}`}
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getAgentList(newInputValue, "");
                  }, 1000);
                  setReportingName(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Reporting Manager"
                    variant="outlined"
                    disabled={designation === "GM SALES"}
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {/* <Autocomplete
                id="zonename"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setZoneName(obj.id)
                  }
                }}
                options={zoneList.results}
                freeSolo
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) => option.city.name}
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current)
                  timer.current = setTimeout(() => {
                    getZone(`${newInputValue}`)
                  }, 1000)
                  if (newInputValue.length === 0) {
                    setZoneName(0)
                  }
                }}
                renderInput={(params) => (
                  <TextField className={classes.input}
                    {...params}
                    placeholder="Zone/City"
                    variant="outlined"
                    style={{ width: "100%", margin: "0", padding: "0" }}
                    required
                  />
                )}
              /> */}
              <TextField
                name="zone"
                variant="outlined"
                select
                label="Zone"
                value={zoneName}
                style={{ width: "100%", margin: "0" }}
                onChange={(e) => setZoneName(e.target.value)}
              >
                <MenuItem value={"none"} disabled>Select Zone</MenuItem>
                <MenuItem value={"North Zone"}>North Zone</MenuItem>
                <MenuItem value={"South Zone"}>South Zone</MenuItem>
                <MenuItem value={"West Zone"}>West Zone</MenuItem>
                <MenuItem value={"East Zone"}>East Zone</MenuItem>

              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                variant="contained"
                color="primary"
                style={{ height: 55 }}
                fullWidth
                disabled={!mobileValidation.mobileNumber}
                type="submit"
              >
                {editButton ? "Update Employee Details" : "Create Employee"}
              </Button>
            </Grid>
            {!editButton ? (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ height: 55 }}
                  fullWidth
                  onClick={() =>
                    history.push("/dashboard/gnadmin/employee_master")
                  }
                >
                  Reset
                </Button>
              </Grid>
            ) : (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ height: 55 }}
                  fullWidth
                  onClick={() =>
                    history.push("/dashboard/gnadmin/employee_master")
                  }
                >
                  Cancel Update
                </Button>
              </Grid>
            )}
          </Grid>
        </Paper>
      </form>
      <Paper elevation={5} className={classes.paper}>
        <Grid
          container
          spacing={3}
          className={classes.centerIt}
          style={{
            margin: "1rem auto",
          }}
        >
          <Grid item xs={12} sm={6} md={2}>
            <h5 style={{ marginTop: 15 }}>Search Option </h5>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              className={classes.input}
              label="Name/Email/Phone No."
              variant="outlined"
              fullWidth
              onChange={(e) => search(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Button
              variant="contained"
              color="secondary"
              style={{ height: "56px" }}
              fullWidth
              onClick={() => history.push("/dashboard/gnadmin/employee_master")}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
        <div
          className="data-table"
          style={{ width: "100%", marginTop: "1rem" }}
        >
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "515px" }}
          >
            {loading ? (
              <Loader />
            ) : (
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center"> Employee Id </StyledTableCell>
                    <StyledTableCell align="center">Employee Name</StyledTableCell>
                    <StyledTableCell align="center">User Name</StyledTableCell>
                    <StyledTableCell align="center">Designation</StyledTableCell>
                    <StyledTableCell align="center">Phone No.</StyledTableCell>
                    <StyledTableCell align="center">Email</StyledTableCell>
                    <StyledTableCell align="center">Zone</StyledTableCell>
                    <StyledTableCell align="center">Reporting Manager</StyledTableCell>
                    <StyledTableCell align="center">Edit</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {employee &&
                    employee.results &&
                    employee.results.length > 0 &&
                    employee.results.map((data: any, index: any) => {
                      return (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="center">{data?.empid}</StyledTableCell>
                          <StyledTableCell align="center">{data?.fullname}</StyledTableCell>
                          <StyledTableCell align="center">{data?.username}</StyledTableCell>
                          <StyledTableCell align="center">{data?.designation}</StyledTableCell>
                          <StyledTableCell align="center">{data?.phonenumber}</StyledTableCell>
                          <StyledTableCell align="center">{data?.email}</StyledTableCell>
                          <StyledTableCell align="center">{data?.type}</StyledTableCell>
                          <StyledTableCell align="center">{String(data?.asigned)}</StyledTableCell>
                          <StyledTableCell align="center">
                            <Button color="primary" variant="contained">
                              <Edit onClick={() => handleEditEmployee(data)} />
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
                <TableFooter>
                  <TablePagination
                    colSpan={6}
                    count={employee.count || 0}
                    rowsPerPageOptions={[]}
                    rowsPerPage={rowsPerPage}
                    // onChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    SelectProps={{
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                  />
                </TableFooter>
              </Table>
            )}
          </TableContainer>
        </div>
      </Paper>
    </main>
  );
};
const mapStateToProps = (state: any) => ({
  employee: state.GenomicsAdminReducer.employee,
  agentsList: state.GenomicsAdminReducer.agentsList,
  zoneList: state.GenomicsAdminReducer.zoneList,
  loading: state.GenomicsAdminReducer.loading,
});
export default connect(mapStateToProps, {
  getEmployee,
  getAgentList,
  postEmployee,
  updateEmployee,
  getZone,
})(EmployeeMaster);
